import { memo } from "react";

export const ReplacementUnavailableDetails = memo(
  function ReplacementUnavailableDetails() {
    return null;
  },
);
